import React from 'react'
import posed from 'react-pose'

const PosedDiv = posed.div({
  start: { opacity: 0, y: '20px' },
  end: {
    opacity: 1,
    y: '0px',
    transition: {
      duration: 500,
    },
  },
})

const PosedMountWrapper = ({ children, className }) => {
  return (
    <PosedDiv initialPose="start" pose="end" className={className}>
      {children}
    </PosedDiv>
  )
}

export default PosedMountWrapper
